import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { TextNode } from 'lexical';
import React from 'react';
import { lexicalTextEditorConfig } from '../editors';
import { ColorlessTextNode } from '../nodes/ColorlessTextNode';
import { ResetStylesPlugin } from '../Plugins/ResetStylesPlugin';
import { mainTheme } from '../Theme/mainTheme';

const editorConfig = {
  namespace: 'text-preview-editor',
  editable: false,
  theme: mainTheme,
  onError: (error: Error): void => {
    throw error;
  },
  nodes: [
    ...lexicalTextEditorConfig.nodes,
    ColorlessTextNode,
    {
      replace: TextNode,
      with: (node: TextNode): ColorlessTextNode => new ColorlessTextNode(node.__text),
      withKlass: ColorlessTextNode,
    },
  ],
};

type Props = {
  editorState: string | null;
  referencesMap: Record<string, number>;
};

export const LexicalTextPreviewEditor = (props: Props): JSX.Element => {
  const { editorState } = props;

  return (
    <LexicalComposer initialConfig={{
      ...editorConfig,
      editorState,
    }} >
      <div className="editor-container">
        <RichTextPlugin
          contentEditable={<ContentEditable className="editor-input" data-testid="editor-input"/>}
          ErrorBoundary={LexicalErrorBoundary}
        />
        <ResetStylesPlugin/>
      </div>
    </LexicalComposer>
  );
};
